import React from "react"
import DfbIcon from "../ui-kit/dfb_icon"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbRte from "../ui-kit/dfb_rte"
import { concatStrings } from "../utilities"
import content from "../../content"

const CAccountBenefits = ({ add_class }) => {
  const baseClass = "c-AccountBenefits"

  return (
    <div className={concatStrings(baseClass, add_class)}>
      <ul className={`${baseClass}-list`}>
        {content.accountBenefits.map(item => (
          <li className={`${baseClass}-item`} key={item.icon}>
            <div className={`${baseClass}-icon`}>
              <DfbIcon icon_type={item.icon} />
            </div>
            <div className={`${baseClass}-text`}>
              <DfbHeadline headline={item.headline} headline_level="h5" />
              <DfbRte text={item.richtext} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CAccountBenefits
